import medicinehome from "../../Assets/medicinehome.png"
import delivered1 from "../../Assets/delivered1.png"
import delivered2 from "../../Assets/delivered2.png"
import delivered3 from "../../Assets/delivered3.png"
import delivered4 from "../../Assets/delivered4.png"
import delivered5 from "../../Assets/delivered5.png"
import delivered6 from "../../Assets/delivered6.png"
import delivered7 from "../../Assets/delivered7.png"
import delivered8 from "../../Assets/delivered8.png"
import delivered9 from "../../Assets/delivered9.png"
import delivered10 from "../../Assets/delivered10.png"
import prescription from "../../Assets/prescription.png"
import rightfit1 from "../../Assets/rightfit1.png"
import rightfit2 from "../../Assets/rightfit2.png"
import rightfit3 from "../../Assets/rightfit3.png"
import rightfit4 from "../../Assets/rightfit4.png"
import queries from "../../Assets/queues.png"
import rupesh from "../../Assets/rupesh.png"
import baskar from "../../Assets/baskar.png"
import naveen from "../../Assets/naveen.png"

export const serviceShowcaseData = [
  {
    imgSrc: medicinehome,
    title: `Stay Stocked Up \n On Medicines \n Convenience In \n Every Dose`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  },
];

export const medicineHeading1 = `Ride The Wave Of Convenience`
export const medicineParagraph1 = `Get your medicine delivered straight to your door because health shouldn't wait. With Wihan medicine home delivery service, \n you can upload your prescriptions and well handle the rest. Whether you're managing a chronic condition or just need a refill, \n we make it easy to stay on top of your health. It's convenient, reliable, and one less thing to worry about.\n Because when it comes to your health, every moment counts.`

export const cardsh2 = `Medicines Delivered`;
export const cardsh4 = `Worries Relieved`
export const cardspara = `From prescriptions to over-the-counter remedies, we've got you covered`

export const medicinedelivered = {
  o1: { title: "Diabetes", img: delivered1 },
  o2: { title: "Cardiac Care", img: delivered2 },
  o3: { title: "Derma Care", img: delivered3 },
  o4: { title: "Eye Care", img: delivered4 },
  o5: { title: "Respiratory Care", img: delivered5 },
  o6: { title: "Kidney Care", img: delivered6 },
  o7: { title: "Liver Care", img: delivered7 },
  o8: { title: "Surgical", img: delivered8 },
  o9: { title: "Mom Baby Care", img: delivered9 },
  o10: { title: "Bone, Joint & Muscle Care", img: delivered10 },
};

export const prescriptiondata = {
  title: `Feeling Unwell`,
  subheading: `But Don’t Have A Prescription`,
  para: `Start A Consultation With Our Panel Of Doctors & \n Order Medicine Through Valid Prescriptions`,
  image: prescription,
 }

export const rightfittitle = `Why We’re The Right Fit`;
export const rightfitdata = {
  o1: { title: "Comprehensive Range", img: rightfit1 },
  o2: { title: "Stringent Quality Checks", img: rightfit2 },
  o3: { title: "Barcoded Medicines", img: rightfit3 },
  o4: { title: "Reliability", img: rightfit4 },
}

export const pharmacyqueuesdata = {
  title: `Say Goodbye To Pharmacy Queues`,
  subheading: `Hello To Hassle-Free Delivery`,
  para: `With Wihan medicine home delivery service, you no longer need to \n waste time standing in long pharmacy lines or battling traffic to pick up \n your prescriptions. Instead, we bring your medications directly to your \n doorstep, ensuring a seamless and stress-free experience every time.`,
  image: queries,
}

export const medicinehomeData = [
  {
    title: `Join The Wave Of Satisfied Customers`,
    desc: `I've been using Wihan Home health care services for medicine delivery
for over a year now, and I couldn't be happier. Their deliveries are always
on time, and their customer service is top-notch. It has made managing
my chronic condition so much easier.`,
    userimg: rupesh,
    username: "Rupesh Kumar"
  },
  {
    title: `Join The Wave Of Satisfied Customers`,
    desc: `I've been using Wihan Home Health Care Services for my monthly
prescriptions, and I'm impressed with their professionalism and
efficiency. Their delivery service has been a godsend, especially
during times when leaving home isn't an option.`,
    userimg: baskar,
    username: "Baskar Kethavath"
  },
  {
    title: `Join The Wave Of Satisfied Customers`,
   desc: `Wihan Home Health Services has made getting medical supplies so convenient. Their team ensures timely delivery every single time, and the packaging is always neat and secure. Managing my medications has become completely hassle-free thanks to their reliable service.`,

    userimg: naveen,
    username: "Naveen Reddy"
  },
]